import React from "react"
import "../styles/index.scss"
import { graphql } from "gatsby"
import { Header } from '../components/header';
import Seo from "../components/seo"
import BlogList from "../components/blog-list"
import HomeHero from "../components/home/home-hero"
import { Footer } from "../components/footer";

class HomePage extends React.Component {
  
  render() {
    return (
        <div className="container">
            <Seo />
            <Header />
            <main>
                <HomeHero/>
                <BlogList/>
            </main>
            <Footer/>
        </div>
    )
  }
}

export default HomePage

export const data = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
